import React from 'react'
import i18next from 'i18next'
import { LinkProps, LinkLayout } from '../../../../../Shared/Frontend/utils/links'
import { dataLayerServices } from '../../../seo/datalayer'
import { Link } from 'react-router-dom'
import { DisplayType } from './cmsSiteHeader.state'
const t = i18next.getFixedT('nl', 'Header')

const toggleDropdown = (key: string, forceState: 'open' | 'close' | null) => {
  const dropdown:HTMLElement|null = document.querySelector("#md-" + key);
  const trigger:HTMLElement|null = document.querySelector("#mdl-" + key);
  const mobileTrigger:HTMLElement|null = document.querySelector("#mdb-" + key);
  const submenu:HTMLElement|null = document.querySelector("#mdd-" + key);

  if((dropdown == null || trigger == null || mobileTrigger == null || submenu == null)) return;

  if(((dropdown.classList.contains('active') && forceState == null) || forceState == 'close')) {
    dropdown.classList.remove('active')
    mobileTrigger.setAttribute('aria-expanded', 'false')
    submenu.setAttribute('aria-hidden', 'true')
    submenu.setAttribute('hidden', 'true')
   } else if(((!dropdown.classList.contains('active') && forceState == null) || forceState == 'open')) {
    dropdown.classList.add('active')
    mobileTrigger.setAttribute('aria-expanded', 'true')
    submenu.setAttribute('aria-hidden', 'false')
    submenu.removeAttribute('hidden')
  }
}

export type CMSHeaderMenuLayoutStyle = {
  navItem: string
  navItemDropdown: string
  navLink: string
  navLinkActive: string
  navSubItem: string
  navSubLink: string
  navSubLinkActive: string
  dropdownButton: string
  dropdownButtonInactive: string
  dropdownButtonActive: string
  dropdownButtonShow: string
  dropdownList: string
}

export const CMSHeaderMenuLayoutClasses: CMSHeaderMenuLayoutStyle = {
  navItem: 'sh__nav-item',
  navItemDropdown: 'sh__nav-item dropdown',
  navLink: 'sh__nav-link link',
  navLinkActive: 'sh__nav-link link active',
  navSubItem: 'sh__nav-subitem',
  navSubLink: 'sh__nav-sublink',
  navSubLinkActive: 'sh__nav-sublink active',
  dropdownButton: 'sh__nav-dropdown link link--iconed link--iconed-right',
  dropdownButtonInactive: 'sh__nav-dropdown link inactive',
  dropdownButtonActive: 'sh__nav-dropdown link active',
  dropdownButtonShow: 'show',
  dropdownList: '',
}


export const CMSHeaderMenuLayout = {
  ItemLink: (props: {
    linkKey: string
    title: string
    children?: JSX.Element | string
    isActive: boolean
    link: LinkProps
    classNames?: string
    activeClassNames?: string
    itemClassNames?: string
    onClickCallback: () => void
    showAsALink?: boolean
  }) =>
    <li className={CMSHeaderMenuLayoutClasses.navItem}>
      <LinkLayout
        className={`${
          props.isActive === true
            ? props.activeClassNames || CMSHeaderMenuLayoutClasses.navLinkActive
            : props.classNames || CMSHeaderMenuLayoutClasses.navLink
        }`}
        onClick={() => props.onClickCallback()}
        link={props.link}
      >
        {props.children}
      </LinkLayout>
    </li>,
  ItemDropdown: (props: {
    linkKey: string
    title: string
    children: JSX.Element
    isActive: boolean
    link: LinkProps
    classNames?: string
    activeClassNames?: string
    itemClassNames?: string
    onClickCallback: () => void
    displayType: DisplayType
  }) => (
    <li
      id={"m-" + props.linkKey}
      className={CMSHeaderMenuLayoutClasses.navItemDropdown}
      onMouseLeave={() => {
        if(props.displayType == 'desktop') { toggleDropdown(props.linkKey, 'close') }
      }}
    >
      <div id={"md-" + props.linkKey} className={`sh__dropdown${props.displayType == 'mobile' && props.isActive ? ' active' : ''}`}>
        <LinkLayout
          id={"mdl-" + props.linkKey}
          className={`${
            props.isActive === true
              ? props.activeClassNames || CMSHeaderMenuLayoutClasses.navLinkActive
              : props.classNames || CMSHeaderMenuLayoutClasses.navLink
          }`}
          onClick={() => {
            toggleDropdown(props.linkKey, 'close')
            props.onClickCallback()
          }}
          onMouseEnter={() => {
            if(props.displayType == 'desktop') {  toggleDropdown(props.linkKey, 'open') }
          }}
          onFocus={() => {
            if(props.displayType == 'desktop') { toggleDropdown(props.linkKey, 'open') }
          }}
          onBlur={() => {
            const focusWithin:HTMLElement|null = document.querySelector("#m-" + props.linkKey + ":focus-within");
            if(focusWithin == null && props.displayType == 'desktop') { toggleDropdown(props.linkKey, 'close') }
          }}
          link={props.link}
        >
          <span className="link__label">{props.link.title}</span>
          <svg className="link__dropicon" width="10px" height="6px" aria-hidden="true">
            <use xlinkHref="#icon--chevron-down" />
          </svg>
        </LinkLayout>

        <button
          id={"mdb-" + props.linkKey}
          className="menudrop"
          aria-controls={"mdd-" + props.linkKey}
          aria-expanded={props.displayType == 'mobile' && props.isActive ? true : false}
          onClick={() => {
            if(props.displayType == 'mobile') { toggleDropdown(props.linkKey, null) }
          }}
          tabIndex={props.displayType == 'desktop' ? -1 : undefined}
        >
          <svg className="menudrop__icon" width="10px" height="6px" aria-hidden="true">
            <use xlinkHref="#icon--chevron-down" />
          </svg>
        </button>
      </div>

      <div id={"mdd-" + props.linkKey} className='menudrop__wrap' aria-hidden={props.displayType == 'mobile' && props.isActive ? 'false' : 'true'} hidden={props.displayType == 'mobile' && props.isActive ? undefined : true}>
        <ul className="menudrop__list">
          {props.children}
        </ul>
      </div>
    </li>
  ),
  ItemDropdownLink: (props: {
    linkKey: string
    title: string
    children?: JSX.Element | string
    isActive: boolean
    link: LinkProps
    classNames?: string
    activeClassNames?: string
    itemClassNames?: string
    onClickCallback: () => void
    showAsALink?: boolean
    displayType: DisplayType
  }) =>
    <li id={"mddl-" + props.linkKey} className='menudrop__item'>
      <LinkLayout
        className={`${
          props.isActive === true
            ? 'menudrop__link active'
            : 'menudrop__link'
        }`}
        onClick={() => {
          toggleDropdown(props.linkKey, 'close')
          props.onClickCallback()
        }}
        onBlur={() => {
          const focusWithin:HTMLElement|null = document.querySelector("#mdd-" + props.linkKey + ":focus-within");
          if(focusWithin == null && props.displayType == 'desktop') { toggleDropdown(props.linkKey, 'close') }
        }}
        link={props.link}
      >
        <span className="menudrop__label">{props.link.title}</span>
      </LinkLayout>
    </li>,
  DonateButton: (props: { onClick: () => void, hide: boolean, hideLink?: boolean, children?: JSX.Element }) => (
    !props.hide ?
    <li className="sh__extra-item sh__extra-item--donate d" key="dk-e-d">
      {!props.hideLink ?
      <Link
        className="button button--primary"
        to={"/doneren"}
        onClick={() => {
          dataLayerServices.menuItemDataLayer("Doneren", '')
          props.onClick()
        }}
        onBlur={() => {
          if(document.querySelector('.sh__mobmenu:focus-within') == null) { props.onClick() }
        }}
      >
        <span className="button__label">{t("DonateButton")}</span>
      </Link> : <></>}
      {props.children}
    </li> : <></>
  ),
  NewsletterButton: (props: { onClick: () => void, hide: boolean, path: string }) => (
    !props.hide ?
      <Link
        className="button button--tertiary"
        to={props.path}
        onClick={() => {
          dataLayerServices.menuItemDataLayer("Nieuwsbrief", '')
          props.onClick()
        }}
        onBlur={() => {
          if(document.querySelector('.sh__mobmenu:focus-within') == null) { props.onClick() }
        }}
      >
        <span className="button__label">{t("NewsletterButton")}</span>
      </Link> : <></>
  )
}
